// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1a1MQ","wrapper":"header-module--wrapper--2o7T6","links":"header-module--links--arN7S","link":"header-module--link--2yTr3"};